import { ref, watch } from 'vue';
import PostSaleCasesAPI from 'dashboard/api/postSaleCases';
import SalesTransactionsAPI from 'dashboard/api/salesTransactions';

const messageFrom = (error, fallback) =>
  error?.response?.data?.message || error?.response?.data?.error || fallback;

export function usePostSaleSalesDetail({ id, t }) {
  const error = ref('');
  const loading = ref(false);
  const postSaleCase = ref(null);
  const transaction = ref(null);
  let requestSequence = 0;

  const clear = () => {
    postSaleCase.value = null;
    transaction.value = null;
  };

  const load = async postSaleCaseId => {
    requestSequence += 1;
    const sequence = requestSequence;
    clear();
    error.value = '';

    if (!postSaleCaseId) return null;

    loading.value = true;
    try {
      const { data: caseData } = await PostSaleCasesAPI.show(postSaleCaseId);
      if (sequence !== requestSequence) return null;

      const transactionId = caseData?.property_transaction_id;
      if (!transactionId) throw new Error(t('POST_SALE.ALERTS.LOAD_ERROR'));

      const { data: transactionData } =
        await SalesTransactionsAPI.show(transactionId);
      if (sequence !== requestSequence) return null;

      postSaleCase.value = caseData;
      transaction.value = transactionData;
      return { postSaleCase: caseData, transaction: transactionData };
    } catch (requestError) {
      if (sequence !== requestSequence) return null;

      clear();
      error.value = messageFrom(requestError, t('POST_SALE.ALERTS.LOAD_ERROR'));
      return null;
    } finally {
      if (sequence === requestSequence) loading.value = false;
    }
  };

  watch(id, load, { immediate: true });

  return { error, load, loading, postSaleCase, transaction };
}
